var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 31,
    rx: 5.5,
    stroke: "#DFE3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0166 22.85C26.4261 24.1907 24.3629 25 22.1084 25C17.078 25 13 20.9706 13 16C13 11.0294 17.078 7 22.1084 7C24.3629 7 26.4261 7.80934 28.0166 9.15001C29.6071 7.80934 31.6703 7 33.9248 7C38.9552 7 43.0331 11.0294 43.0331 16C43.0331 20.9706 38.9552 25 33.9248 25C31.6703 25 29.6071 24.1907 28.0166 22.85Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0166 22.8499C29.975 21.1992 31.2168 18.7429 31.2168 16C31.2168 13.2571 29.975 10.8008 28.0166 9.15005C29.6071 7.80935 31.6703 7 33.9248 7C38.9553 7 43.0332 11.0294 43.0332 16C43.0332 20.9706 38.9553 25 33.9248 25C31.6703 25 29.6071 24.1906 28.0166 22.8499Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0166 22.85C29.975 21.1992 31.2168 18.7429 31.2168 16C31.2168 13.2571 29.975 10.8008 28.0166 9.15004C26.0582 10.8008 24.8164 13.2571 24.8164 16C24.8164 18.7429 26.0582 21.1992 28.0166 22.85Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.d48bc1309dfd0db8d99c95ffb840bae7.svg";
export { ForwardRef as ReactComponent };